module.exports = __webpack_public_path__ + "static/img/chenggong.a757154.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/chenggong.png
// module id = 674
// module chunks = 1